import { render, staticRenderFns } from "./NewsHome.vue?vue&type=template&id=79b8ce46&scoped=true&"
import script from "./NewsHome.vue?vue&type=script&lang=js&"
export * from "./NewsHome.vue?vue&type=script&lang=js&"
import style0 from "./NewsHome.vue?vue&type=style&index=0&id=79b8ce46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b8ce46",
  null
  
)

export default component.exports